import { Log } from '../../shared/log';
const log = new Log('services.componentLookup.service');

import { GenericRotatingWidgetComponent } from '../../widgets/generic-rotating/rotating-widget.component';
import { TemplateDrivenWidgetComponent } from '../../widgets/templateDrivenWidget/template-driven-widget.component';

export class ComponentLookupService {

  // widget components -- need this list to handle minification of class name
  // key will not be minified (LHS), but object name will be (RHS)
  // { val1, val2, val3 ... } is ES2015 shorthand
  // see: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Object_initializer
  private componentMap = {
    GenericRotatingWidgetComponent,
    TemplateDrivenWidgetComponent
};


  get(componentName: string) {
    const component = this.componentMap[componentName];
    if (!component) {
      const message = `component '${componentName}' is not in the list of available components.  Did you add it to ComponentLookupService?`;
      log.error(message);
      throw new Error(message);
    }
    return component;
  }
}



// WEBPACK FOOTER //
// ./app/services/widget/componentLookup.service.ts